import { Component } from '@angular/core';

@Component({
  selector: 'app-section-inscricoes-abertas',
  templateUrl: './section-inscricoes-abertas.component.html',
  styleUrls: ['./section-inscricoes-abertas.component.scss'],
})
export class SectionInscricoesAbertasComponent {}
